module.exports = __webpack_public_path__ + "res/img/dgsq.7c74190f.png";